module.exports = __webpack_public_path__ + "assets/green_check_line-1c1daf.svg";